/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UserPasswordResetInput = {
    token: string;
    newPassword: string;
};
export type PasswordResetFormMutationVariables = {
    input: UserPasswordResetInput;
};
export type PasswordResetFormMutationResponse = {
    readonly userPasswordReset: {
        readonly user: {
            readonly username: string;
        };
    };
};
export type PasswordResetFormMutation = {
    readonly response: PasswordResetFormMutationResponse;
    readonly variables: PasswordResetFormMutationVariables;
};



/*
mutation PasswordResetFormMutation(
  $input: UserPasswordResetInput!
) {
  userPasswordReset(input: $input) {
    user {
      username
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordResetFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserPasswordResetPayload",
        "kind": "LinkedField",
        "name": "userPasswordReset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PasswordResetFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserPasswordResetPayload",
        "kind": "LinkedField",
        "name": "userPasswordReset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7b8668d487adda770644cb39de047a8d",
    "id": null,
    "metadata": {},
    "name": "PasswordResetFormMutation",
    "operationKind": "mutation",
    "text": "mutation PasswordResetFormMutation(\n  $input: UserPasswordResetInput!\n) {\n  userPasswordReset(input: $input) {\n    user {\n      username\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b7423c49109b4176ad2843d408244e54';
export default node;
